import React from "react";

import cpImg from "../Assets/img/course/Rectangle 1009.png";
import pbImg from "../Assets/img/course/Rectangle 1012.png";
import dsImg from "../Assets/img/course/Rectangle 1011.png";
import wdImg from "../Assets/img/course/Rectangle 1010.png";
import { Link } from "react-router-dom";
import "./course.css";
function cProgramming() {
	let array = [
		{
			name: "Competitive",
			secondName: "Programming",
			srcImg: cpImg,
			linkTo: "/cpcourse",
		},
		{
			name: "Get Placement",
			secondName: "Ready",
			srcImg: pbImg,
			linkTo: "/placementcourse",
		},
		{
			name: "Web",
			secondName: " Development",
			linkTo: "Na",
			srcImg: wdImg,
		},
		{
			name: "Data",
			secondName: "Science",
			linkTo: "Na",
			srcImg: dsImg,
		},
	];
	return (
		<div className="container" style={{ justifyContent: "space-between" }}>
			<div className="row">
				{array.map((item) => (
					<div className="col-xs-12 col-sm-6 col-md-3">
						<div className="box">
							<div className="course-grid">
								<img
									className="cp-course-img"
									src={item.srcImg}
								/>
								<p className="cp-course-text">
									{item.name} <br /> {item.secondName}
								</p>
								<div className="explore-container">
									{item.linkTo === "Na" ? (
										<div
											className="explore-container"
											//className="syllabus-btn"
											style={{
												marginTop: "48px",
												marginLeft: "-10%",
												color: "grey",
												fontSize: "medium",
											}}
										>
											Coming Soon...
										</div>
									) : (
										<Link to={item.linkTo}>
											<button
												className="syllabus-btn"
												style={{
													backgroundColor: "#FFC600",
													marginTop: "30px",
													color: "white",
													width: "50%",
													maginLeft: "-10%",
												}}
											>
												Know More
											</button>
										</Link>
									)}
								</div>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}

export default cProgramming;
{
	/*
    {/*<div className="col-xs-12 col-sm-6 col-md-3">
          <div className="box">
            <div className="course-grid">
              <img className="cp-course-img" src={cpImg} />
              <p className="cp-course-text">
                Competitive <br /> Programming
              </p>

              <Link to="/cpcourse">
                {" "}
                <div className="explore-container">
                  <button className="syllabus-btn" style={{ marginTop: "48px" }}>
                    Explore
                  </button>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className="col-xs-12 col-sm-6 col-md-3">
          <div className="box">
            <div className="course-grid">
              <img className="cp-course-img" src={pbImg} />
              <p className="cp-course-text">
                Get Placement <br /> Ready
              </p>
              <div className="explore-container">
                <Link to="/placementcourse">
                  <button className="syllabus-btn" style={{ marginTop: "48px" }}>
                    Explore
                  </button>
                </Link>
              </div>
            </div>
          </div> 
        </div> 
		 <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3 mr-2">
          <div className="box">
            <div className="course-grid">
              <img
                className="cp1-course-img"
                style={{
                  height: "55%",
                  width: "70%",
                  marginTop: "48px",
                  textAlign: "center",
                }}
                src={cpImg}
              />
              <p className="cp-course-text">Competitive Programming</p>
              <Link to="/cpcourse">
                <div className="explore-container">
                  <button className="syllabus-btn" style={{ marginTop: "48px" }}>
                    Explore
                  </button>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className="col-xs-12 col-sm-6 col-md-3">
          <div className="box">
            <div className="course-grid">
              <img className="cp-course-img" src={pbImg} />
              <p className="cp-course-text">
                Placement <br /> Bundle
              </p>
              <Link to="/">
                <div className="explore-container">
                  <button className="syllabus-btn" style={{ marginTop: "48px" }}>
                    Explore
                  </button>
                </div>
              </Link>
            </div>
          </div>
        </div> 
        <div className="col-xs-12 col-sm-6 col-md-3">
          <div className="box">
            <div className="course-grid">
              <img className="cp-course-img" src={wdImg} />
              <p className="cp-course-text">
                Web <br /> Development
              </p>{" "}
              <div
                className="explore-container"
                style={{ marginTop: "30%", color: "grey" }}
              >
                Coming Soon...
                {/*
                      <button
                        className="syllabus-btn"
                        style={{ marginTop: "48px" }}
                      >
                        Explore
                      </button>
</div>
            </div>
          </div>
        </div>
        <div className="col-xs-12 col-sm-6 col-md-3">
          <div className="box">
            <div className="course-grid">
              <img className="cp-course-img" src={dsImg} />
              <p className="cp-course-text">
                Data <br />
                Science
              </p>
              <div
                className="explore-container"
                style={{ marginTop: "30%", color: "grey" }}
              >
                Coming Soon...
                {/*
                <button className="syllabus-btn" style={{ marginTop: "48px" }}>
                  Explore
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
			</div> 



 */
}
